module.exports = __webpack_public_path__ + "static/media/home_page_archero2_background_m@2x.5cd66c20.png";